export default "__VITE_ASSET__qzyiSaLj__"